import getApiUrl from "../utils/getApiUrl";
import fetch from "../utils/mgFetch";

const getActiveUsersBetweenDates = (
    token: string,
    backend: string,
    fromDate: string,
    toDate: string,
) => {
    return fetch(
        `${getApiUrl(backend)}active_users_between_dates/${fromDate}/${toDate}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getActiveUsersBetweenDates;
